"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
function ExportFiles({ csvHeaders, handlePrint, csvData, fileName, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "actions", children: [(0, jsx_runtime_1.jsx)("style", { children: `@page { margin: 40px !important; }` }), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.ExportCSV, { csvHeaders: csvHeaders, title: 'Export to CSV', csvData: csvData, fileName: fileName }), (0, jsx_runtime_1.jsx)("button", { onClick: handlePrint, className: "export-to-pdf m-l-20", children: "Print to PDF" })] })] }));
}
exports.default = ExportFiles;
